export default __webpack_public_path__ + "benefits-section.png";